import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icons/essential/10-close-big.svg'
import _imports_1 from '@/assets/icons/essential/07-arrow-right.svg'


const _hoisted_1 = { class: "node-inputs--container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["value", "onInput", "id"]
const _hoisted_4 = ["onUpdate:modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_object_tree_nested_node = _resolveComponent("object-tree-nested-node")!
  const _component_ozn_button = _resolveComponent("ozn-button")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keyIndex, (node, i) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "object-tree--node",
      key: `${_ctx.id}-${node.index}-${node.key}`,
      "data-cy": "object-tree-node"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "node-input--remove",
          onClick: e => _ctx.removeNode(node.key, _ctx.data, e)
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("img", {
            class: "icon remove-icon",
            "svg-inline": "",
            src: _imports_0,
            alt: "remove"
          }, null, -1)
        ]), 8, _hoisted_2),
        _createElementVNode("input", {
          class: "node-input node-input--key",
          value: node.key,
          onInput: e => _ctx.dbSetNodeKey(node.key, _ctx.data, e, `${_ctx.id}-${node.index}`),
          id: `${_ctx.id}-${node.index}`
        }, null, 40, _hoisted_3),
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          class: "icon link-icon",
          "svg-inline": "",
          src: _imports_1,
          alt: "links to"
        }, null, -1)),
        (typeof _ctx.data[node.key] === 'object')
          ? (_openBlock(), _createBlock(_component_object_tree_nested_node, {
              key: 0,
              modelValue: _ctx.data[node.key],
              "onUpdate:modelValue": [($event: any) => ((_ctx.data[node.key]) = $event), _ctx.update],
              suggestions: _ctx.suggestions
            }, null, 8, ["modelValue", "onUpdate:modelValue", "suggestions"]))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "node-input node-input--value",
              "onUpdate:modelValue": ($event: any) => ((_ctx.data[node.key]) = $event)
            }, null, 8, _hoisted_4)), [
              [_vModelText, _ctx.data[node.key]]
            ])
      ]),
      (typeof _ctx.data[node.key] === 'object')
        ? (_openBlock(), _createBlock(_component_ozn_button, {
            key: 0,
            class: "minimal",
            onClick: ($event: any) => (_ctx.addNode(_ctx.data[node.key]))
          }, {
            default: _withCtx(() => [
              _createTextVNode("+ " + _toDisplayString(_ctx.label), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}